import React from 'react';
import ReactDOM from 'react-dom';
import { setTranslations, setLanguage, t } from 'react-switch-lang';
import { setUser as setSentryUser } from '@sentry/react';

import App from './App';
import jwtVerify from './utils/Jwt';
import { isProduction } from './utils/HostingEnv';
import initSentry from './utils/Sentry';
import { events, initAmplitude, logAmpEvent, setAmpUser, setPartnerName } from './utils/Amplitude';
import PaymentDemo from './components/PaymentDemo';
import ErrorPage from './components/ErrorPage';
import LoadingPage from './components/LoadingPage';
import English from './languages/English.json';
import French from './languages/French.json';
import CustomErrorPage from './components/CustomErrorPage';
import { ItalicizeInterac } from './components/ReplaceTextWithElement';

if (isProduction) initSentry();
setTranslations({
  en: English,
  fr: French,
});

const searchParam = new URLSearchParams(window.location.search);
const seq = searchParam.get('pps');
const jwt = searchParam.get('jwtHost');
const testMode = searchParam.get('TestMode') === 'y';
const showFakeBankPage = !!searchParam.get('payment_demo');
const amount = parseFloat(searchParam.get('amount')) || 0;
const loadingInteracPage = searchParam.get('loading') === 'true';
const errorCode = searchParam.get('error_code');
const lang = searchParam.get('lang') === 'fr' ? 'fr' : 'en';
setLanguage(lang);
document.documentElement.setAttribute('lang', lang); // set <html> lang attr
setPartnerName(searchParam); // store pne & pnf searchParams when the app is loaded
initAmplitude(testMode);
if (testMode && showFakeBankPage) {
  const id = searchParam.get('id');
  if (id) {
    setAmpUser(id);
    if (isProduction) setSentryUser({ id });
  }
}

if (loadingInteracPage) {
  ReactDOM.render(
    (
      <LoadingPage>
        <h1>{t('PaymentInitiated_LoadingInteracPage1', null, lang)}</h1>
        <p><ItalicizeInterac text={t('PaymentInitiated_LoadingInteracPage2', null, lang)} /></p>
      </LoadingPage>
    ), document.getElementById('root')
  );
} else if (errorCode) {
  ReactDOM.render(<CustomErrorPage
    errorCode={errorCode}
    lang={searchParam.get('lang')}
    returnUrl={searchParam.get('return')}
  />, document.getElementById('root'));
} else {
  jwtVerify(jwt, seq).then((exp) => {
    if (isProduction && exp && (!searchParam.get('pne') || !searchParam.get('pnf'))) {
      logAmpEvent(events.NO_PARTNER_NAME_PROVIDED);
    }
    if (!exp) {
      ReactDOM.render(<ErrorPage ampProp={{ Error: 'Invalid query parameters.' }} />, document.getElementById('root'));
    } else if (exp < Date.now()) {
      ReactDOM.render(<ErrorPage
        titleKey="PaymentExpired_Title"
        ampEvent={events.USER_VIEWED_JWT_EXPIRED_PAGE}
        ampProp={{ PartnerPaySeq: seq }}
      />, document.getElementById('root'));
    } else if (showFakeBankPage) {
      ReactDOM.render(<PaymentDemo seq={seq} jwt={jwt} exp={exp} amount={amount} />, document.getElementById('root'));
    } else {
      ReactDOM.render(<App seq={seq} jwt={jwt} exp={exp} testMode={testMode} />, document.getElementById('root'));
    }
  });
}
